import { render, staticRenderFns } from "./clock.vue?vue&type=template&id=51a5bb2f&"
import script from "./clock.vue?vue&type=script&lang=js&"
export * from "./clock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports